import { Pressable } from '@react-aria/interactions'

import Styles from './ReferralBannerCTA.module.scss'

import { Text } from 'blaze-ui/Text/Text'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { Close } from 'blaze-ui/icons/16'
import { useCreateCardDismissal } from 'hooks/queries/useCreateCardDismissal'
import { useModals } from 'almanac-ui/Modal'
import { ArrowRight } from 'blaze-ui/icons'
import { ReferralModalV2 } from 'components/Settings/ReferralModalV2/ReferralModalV2'

export const ReferralBannerCTA = () => {
  const { mutate: dismissCard } = useCreateCardDismissal()
  const { openModal } = useModals()

  const openReferralModal = () => {
    openModal(ReferralModalV2, {
      onAction: () => dismissCard('left_rail_referral_cta'),
    })
  }

  const closeReferralCTA = () => {
    dismissCard('left_rail_referral_cta')
  }

  return (
    <Pressable onPress={openReferralModal}>
      <div className={Styles.referralContainer}>
        <div className={Styles.textAndIcon}>
          <Text variant="smallList">Get a free month of Blaze for referring friends. Get Your Link</Text>
          <div className={Styles.iconContainer}>
            <ArrowRight size={16} />
          </div>
        </div>
        <IconButton variant="tertiary" size="xs" icon={Close} onPress={closeReferralCTA} />
      </div>
    </Pressable>
  )
}
